import { GetB2bAdminsShowResponse } from '@Common/types/bo/b2b/admins';
import { GetLoginLinkResponse } from '@Common/types/bo_external/auth/magic_link';

export const b2bAdminsTranslations = {
  title: 'B2B Admins',
  fields: {
    id: 'Admin ID',
    email: 'Email',
    email_state: 'Email state',
    status: 'Status',
    created_at: 'Created at',
    updated_at: 'Updated at',
    company_id: 'Company ID',
    company_name: 'Company Name',
    role_in_company: 'Role in company',
    firstname: 'First Name',
    lastname: 'Last Name',
    phone_number: 'Phone Number',
    secondary_email: '2nd email for 2FA',
    secondary_email_state: '2nd email state',
    last_invitation_sent_at: 'Last invitation sent at',
    has_last_otp: 'Last valid OTP',
    ghost_login: 'Ghost login',
    is_migrated: 'Is migrated from AXA',
    email_verified: 'Email verified',
    role: 'Role',
    language_preference: 'Language preference',
    is_third_party: 'Is a third party correspondent',
    third_party_legal_structure: 'Legal structure',
    third_party_mandate_document_id: 'Mandate document',
    gender: 'Title',
    is_mailing_correspondent: 'Is mailing correspondent ?',
    mailing_street: 'Street',
    mailing_postalcode: 'Postal code',
    mailing_city: 'City',
    mailing_country: 'Country',
    is_npai_mailing: 'Is mailing address PND ?',
    npai_mailing_at: 'PND at',
    is_billing_correspondent: 'Is billing correspondent ?',
    billing_channel: 'Invoicing channel',
    billing_street: 'Street',
    billing_postalcode: 'Postal code',
    billing_city: 'City',
    billing_country: 'Country',
    is_npai_billing: 'Is billing address PND ?',
    npai_billing_at: 'PND at',
  } satisfies Record<keyof GetB2bAdminsShowResponse | 'ghost_login' | 'company_name', string>,
  sections: {
    third_party: 'Third party correspondent',
    mailing_address: 'Mailing Address',
    billing_address: 'Billing Address',
  },
  choices: {
    status: {
      active: 'Active',
      inactive: 'Inactive',
      pending: 'Pending',
      invited: 'Invited',
    },
    billing_channel: {
      paper: 'Paper',
      email: 'Email',
      both: 'Paper and email',
    },
  },
  steps: {
    general: 'General details',
    addresses: 'Addresses',
    confirmation: 'Confirmation',
  },
  correspondence: {
    mailing_title: 'Correspondent mailing address',
    billing_title: 'Correspondent billing address',
    company_address_fallback: 'Leave empty to use the company address',
    company_address_used: 'The company address is used',
    yes: 'Yes',
    no: 'No',
  },
  button: 'Create correspondent',
  empty: 'This company has no correspondents yet',
  actions: {
    create: {
      title: 'Create company correspondent',
      success: 'Company correspondent created',
      failure: 'Company correspondent failed to be created: %{error}',
    },
    edit: {
      title: 'Update company correspondent',
      success: 'Company correspondent updated',
      failure: 'Company correspondent failed to be updated: %{error}',
      validation: {
        email_same_as_secondary_email: 'Primary and secondary emails cannot be the same',
      },
    },
    delete: {
      title: 'Delete B2B Admin?',
      content: 'You are about to delete a B2B Admin with ID %{adminId} and email %{email}.',
    },
    request_otp: {
      label: 'Request OTP',
      dialog: {
        title: 'Requested OTP',
        description: 'Provide this OTP to the customer to allow them to reset their password',
      },
    },
    last_otp: {
      show: 'Show last valid OTP',
      hide: 'Hide last valid OTP',
      no_last_otp: 'No last valid OTP',
    },
    send_invite: {
      label: 'Send invite |||| Send invites',
      dialog: {
        title: 'Confirmation',
        confirm:
          'Are you sure you want to send invitation to correspondent? |||| Are you sure you want to send invitations to selected correspondents?',
        success: 'Invitation sent',
        failure: 'Invitation failed to be sent: \n%{error}',
      },
    },
  },
  notifications: {
    last_otp_fetch_error: 'Unable to fetch the last OTP',
    last_otp_unavailable: 'Could not get the code, it has expired or was already used',
  },
  login_link: {
    fields: {
      id: 'Link ID',
      url: 'Ghost login',
    } satisfies Record<keyof GetLoginLinkResponse, string>,
    tooltip: {
      not_activated: 'User must be activated for ghost login to be available',
    },
  },
  third_party_disclaimer:
    'By granting access to this web portal to an external user, you confirm that you have verified their identity and agree that they may view data and features according to the assigned permissions. You are responsible for the level of access granted and must revoke it as soon as it is no longer needed.',
};
